// src/utils/permissionConstants.js
export const PERMISSIONS = {
  SETTINGS: {
    name: "SETTINGS",
    description: "Main settings permissions",
    childrens: [
      {
        name: "BUSINESS_SETTINGS",
        description: "Business settings section",
        childrens: ["ACTIVITY", "SUBSCRIPTION", "USAGE", "BILLING"],
      },
      {
        name: "PROFILE",
        description: "Profile settings",
        childrens: [],
      },
      {
        name: "CHANGE_PASSWORD",
        description: "Password change section",
        childrens: [],
      },
      {
        name: "INTEGRATIONS",
        description: "Integration settings",
        childrens: [
          "CALENDARS",
          "CONFERENCES",
          "AUTOMATION",
          "PAYMENTS",
          "ANALYTICS",
        ],
      },
      "VIEW_SETTINGS",
      "UPDATE_SETTINGS",
    ],
  },
  USERS: {
    name: "USERS",
    description: "Permissions for user management",
    childrens: ["VIEW_USERS", "ADD_USERS", "UPDATE_USERS", "DELETE_USERS"],
  },
  GROUPS: {
    name: "GROUPS",
    description: "Permissions for groups management",
    childrens: ["VIEW_GROUPS", "ADD_GROUPS", "UPDATE_GROUPS", "DELETE_GROUPS"],
  },
  ROLES: {
    name: "ROLES",
    description: "Permissions for roles and permissions",
    childrens: [
      "VIEW_ROLES_PERMISSIONS",
      "ADD_ROLES_PERMISSIONS",
      "UPDATE_ROLES_PERMISSIONS",
      "DELETE_ROLES_PERMISSIONS",
    ],
  },
  SPACES: {
    name: "SPACES",
    description: "Permissions for space management",
    childrens: [
      "VIEW_SPACE_MANAGEMENT",
      "ADD_SPACE_MANAGEMENT",
      "UPDATE_SPACE_MANAGEMENT",
      "DELETE_SPACE_MANAGEMENT",
    ],
  },
  CALENDAR: {
    name: "CALENDAR",
    description: "Permissions for calendar and booking management",
    childrens: [
      "VIEW_CALENDAR",
      {
        name: "MANAGE_EVENT_TYPES",
        description: "Manage event types and booking configurations",
        childrens: [
          "VIEW_EVENT_TYPES",
          "ADD_EVENT_TYPES",
          "UPDATE_EVENT_TYPES",
          "DELETE_EVENT_TYPES",
        ],
      },
      {
        name: "MANAGE_AVAILABILITY",
        description: "Manage personal and team availability",
        childrens: [
          "VIEW_AVAILABILITY",
          "UPDATE_PERSONAL_AVAILABILITY",
          "MANAGE_TEAM_AVAILABILITY",
        ],
      },
      {
        name: "MANAGE_BOOKINGS",
        description: "Manage booking confirmations and scheduling",
        childrens: [
          "VIEW_BOOKINGS",
          "APPROVE_BOOKINGS",
          "RESCHEDULE_BOOKINGS",
          "CANCEL_BOOKINGS",
        ],
      },
      {
        name: "CALENDAR_INTEGRATIONS",
        description: "Manage calendar integrations",
        childrens: [
          "VIEW_INTEGRATIONS",
          "CONNECT_CALENDARS",
          "DISCONNECT_CALENDARS",
        ],
      },
    ],
  },
  WIDGET: {
    name: "WIDGET",
    description: "Permissions for widget and communication management",
    childrens: [
      "VIEW_WIDGET_DASHBOARD",
      {
        name: "MANAGE_CHANNEL_CONNECT",
        description: "Manage website chat widget integration",
        childrens: [
          "VIEW_CHANNEL_CONNECT",
          "UPDATE_WIDGET_SETTINGS",
          "MANAGE_WIDGET_DEPLOYMENT",
        ],
      },
      {
        name: "MANAGE_QR_CONNECT",
        description: "Manage QR code access and mobile connectivity",
        childrens: [
          "VIEW_QR_CONNECT",
          "GENERATE_QR_CODES",
          "UPDATE_QR_SETTINGS",
        ],
      },
      {
        name: "HANDLE_INCOMING_REQUESTS",
        description: "Manage incoming customer requests and communications",
        childrens: [
          "VIEW_INCOMING_REQUESTS",
          "RESPOND_TO_REQUESTS",
          "ESCALATE_TO_VIDEO",
          "START_CO_BROWSING",
        ],
      },
      {
        name: "MANAGE_VISITOR_TRACKING",
        description: "Manage visitor analytics and tracking",
        childrens: [
          "VIEW_VISITOR_ANALYTICS",
          "EXPORT_VISITOR_DATA",
          "CONFIGURE_TRACKING",
        ],
      },
      {
        name: "MANAGE_SUPPORT_TICKETS",
        description: "Manage support ticket system",
        childrens: [
          "VIEW_SUPPORT_TICKETS",
          "CREATE_SUPPORT_TICKETS",
          "UPDATE_SUPPORT_TICKETS",
          "CLOSE_SUPPORT_TICKETS",
        ],
      },
    ],
  },
  EVENTS: {
    name: "EVENTS",
    description: "Permissions for event management and virtual conferences",
    childrens: [
      "VIEW_EVENTS",
      {
        name: "MANAGE_EVENTS",
        description: "Create and manage events",
        childrens: [
          "CREATE_EVENTS",
          "UPDATE_EVENTS",
          "DELETE_EVENTS",
          "DUPLICATE_EVENTS",
        ],
      },
      {
        name: "MANAGE_EVENT_BRANDING",
        description: "Manage event branding and customization",
        childrens: [
          "UPDATE_EVENT_BRANDING",
          "MANAGE_SPONSORS",
          "CUSTOMIZE_LANDING_PAGE",
        ],
      },
      {
        name: "MANAGE_SESSIONS_TRACKS",
        description: "Manage event sessions and tracks",
        childrens: [
          "VIEW_SESSIONS_TRACKS",
          "CREATE_SESSIONS",
          "UPDATE_SESSIONS",
          "DELETE_SESSIONS",
          "MANAGE_TRACKS",
          "SCHEDULE_BREAKS",
        ],
      },
      {
        name: "MANAGE_ATTENDEES",
        description: "Manage event attendees and participants",
        childrens: [
          "VIEW_ATTENDEES",
          "ADD_ATTENDEES",
          "UPDATE_ATTENDEES",
          "DELETE_ATTENDEES",
          "MANAGE_ATTENDEE_TYPES",
          "EXPORT_ATTENDEE_DATA",
        ],
      },
      {
        name: "MANAGE_SPEAKERS",
        description: "Manage event speakers and presenters",
        childrens: [
          "VIEW_SPEAKERS",
          "ADD_SPEAKERS",
          "UPDATE_SPEAKERS",
          "DELETE_SPEAKERS",
          "ASSIGN_SPEAKER_SESSIONS",
        ],
      },
      {
        name: "MANAGE_FORMS_SURVEYS",
        description: "Manage event forms and surveys",
        childrens: [
          "VIEW_FORMS",
          "CREATE_FORMS",
          "UPDATE_FORMS",
          "DELETE_FORMS",
          "VIEW_FORM_RESPONSES",
          "EXPORT_FORM_RESPONSES",
        ],
      },
      {
        name: "MANAGE_EVENT_ANALYTICS",
        description: "Manage event analytics and reporting",
        childrens: [
          "VIEW_EVENT_ANALYTICS",
          "EXPORT_EVENT_REPORTS",
          "VIEW_ATTENDEE_ENGAGEMENT",
        ],
      },
    ],
  },
};
